// Breadcrumb identifiers
const orderDetailsBreadcrumbIdentifier = {
    route: 'orders.details',
    parameterLabel: 'order',
    parameters: ['order', 'client']
}

const orderEditCustomerDataBreadcrumbIdentifier = {
    route: 'orders.edit-customer-details',
    parameterLabel: 'order',
    parameters: ['order', 'client']
}

export default ($page) => {
    return [
        {
            route: 'orders.details',
            label: 'messages.sitemap.orders.details',
            identifier: orderDetailsBreadcrumbIdentifier,
            activeSidebarItemResolver: (props) => {
                let activeRoutes = ['orders.details', 'orders.osa.index', '']
                let expandDropdowns = ['order']

                switch (props.orderData.client) {
                    case 'PSA':
                        activeRoutes = ['orders.details', 'orders.psa.index', '']
                        break
                    case 'WooCommerce':
                        activeRoutes = ['orders.details', 'orders.woocommerce.index', '']
                        break
                    case 'OneWebshop':
                        activeRoutes = ['orders.details', 'orders.one_webshop.index', '']
                        break
                    case 'Webglobe':
                        activeRoutes = ['orders.details', 'orders.webglobe.index', '']
                        break
                    case 'Internal':
                        activeRoutes = ['customers.customers.index', '']
                        expandDropdowns = 'customer'
                        break
                }

                return {
                    activeRoutes: activeRoutes,
                    expandDropdowns: expandDropdowns
                }
            },
            breadcrumbsResolver: (props) => {
                let breadcrumbs = [
                    { href: { route: 'orders.osa.index', params: [] }, text: 'messages.sitemap.orders.orders' },
                    { href: { route: 'orders.osa.index', params: [] }, text: 'messages.sitemap.orders.index_osa' },
                    { href: { route: 'orders.details', params: ['order', 'client'] }, text: String(props.order) },
                    { href: { route: 'orders.details', params: ['order', 'client'] }, text: 'messages.sitemap.orders.details' }
                ]

                switch (props.orderData.client) {
                    case 'PSA':
                        breadcrumbs = [
                            { href: { route: 'orders.psa.index', params: [] }, text: 'messages.sitemap.orders.orders' },
                            { href: { route: 'orders.psa.index', params: [] }, text: 'messages.sitemap.orders.index_psa' },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: String(props.order) },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: 'messages.sitemap.orders.details' }
                        ]
                        break
                    case 'WooCommerce':
                        breadcrumbs = [
                            { href: { route: 'orders.woocommerce.index', params: [] }, text: 'messages.sitemap.orders.orders' },
                            { href: { route: 'orders.woocommerce.index', params: [] }, text: 'messages.sitemap.orders.index_woo_commerce' },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: String(props.order) },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: 'messages.sitemap.orders.details' }
                        ]
                        break
                    case 'OneWebshop':
                        breadcrumbs = [
                            { href: { route: 'orders.one_webshop.index', params: [] }, text: 'messages.sitemap.orders.orders' },
                            { href: { route: 'orders.one_webshop.index', params: [] }, text: 'messages.sitemap.orders.index_one_webshop' },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: String(props.order) },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: 'messages.sitemap.orders.details' }
                        ]
                        break
                    case 'Webglobe':
                        breadcrumbs = [
                            { href: { route: 'orders.webglobe.index', params: [] }, text: 'messages.sitemap.orders.orders' },
                            { href: { route: 'orders.webglobe.index', params: [] }, text: 'messages.sitemap.orders.index_webglobe' },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: String(props.order) },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: 'messages.sitemap.orders.details' }
                        ]
                        break
                    case 'Internal':
                        breadcrumbs = [
                            { href: { route: 'customers.customers.index', params: [] }, text: 'messages.sitemap.customers.customers' },
                            { href: { route: 'customers.customers.index', params: [] }, text: 'messages.sitemap.customers.index' },
                            { href: { route: 'customers.customers.show', params: ['customer'] }, text: String(props.orderData.databaseCustomerId) },
                            { href: { route: 'customers.customers.orders.index', params: ['customer'] }, text: 'messages.sitemap.customers.orders.orders' },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: String(props.order) },
                            { href: { route: 'orders.details', params: ['order', 'client'] }, text: 'messages.sitemap.orders.details' }
                        ]
                        break
                }

                return breadcrumbs
            }
        },
        {
            route: 'orders.edit-customer-details',
            label: 'messages.sitemap.orders.edit-customer-details',
            identifier: orderEditCustomerDataBreadcrumbIdentifier,
            activeSidebarItemResolver: (props) => {
                let activeRoutes = ['orders.edit-customer-details', 'orders.osa.index', '']
                const expandDropdowns = ['order']

                switch (props.orderData.client) {
                    case 'OneWebshop':
                        activeRoutes = ['orders.edit-customer-details', 'orders.one_webshop.index', '']
                        break
                    case 'Webglobe':
                        activeRoutes = ['orders.edit-customer-details', 'orders.webglobe.index', '']
                        break
                }

                return {
                    activeRoutes: activeRoutes,
                    expandDropdowns: expandDropdowns
                }
            },
            breadcrumbsResolver: (props) => {
                let breadcrumbs = [
                    { href: { route: 'orders.edit-customer-details', params: ['order', 'client'] }, text: String(props.order) },
                    { href: { route: 'orders.edit-customer-details', params: ['order', 'client'] }, text: 'messages.sitemap.orders.edit-customer-details' }
                ]

                switch (props.orderData.client) {
                    case 'OneWebshop':
                        breadcrumbs = [
                            { href: { route: 'orders.one_webshop.index', params: [] }, text: 'messages.sitemap.orders.orders' },
                            { href: { route: 'orders.one_webshop.index', params: [] }, text: 'messages.sitemap.orders.index_one_webshop' },
                            { href: { route: 'orders.edit-customer-details', params: ['order', 'client'] }, text: String(props.order) },
                            { href: { route: 'orders.edit-customer-details', params: ['order', 'client'] }, text: 'messages.sitemap.orders.edit-customer-details' }
                        ]
                        break
                }

                return breadcrumbs
            }
        },
        ...($page.props.isOsaOrderSupported
            ? [
                {
                    route: 'orders.osa.index',
                    label: 'messages.sitemap.orders.index_osa',
                    showInSidebar: true,
                    id: 'osa-orders-incoming',
                    children: []
                }
            ]
            : []
        ),
        ...($page.props.isPsaOrderSupported
            ? [
                {
                    route: 'orders.psa.index',
                    label: 'messages.sitemap.orders.index_psa',
                    showInSidebar: true,
                    id: 'psa-orders-incoming',
                    children: [
                        {
                            route: 'orders.psa.automatic-checks',
                            label: 'messages.sitemap.orders.automatic_checks',
                            identifier: orderDetailsBreadcrumbIdentifier
                        },
                        {
                            route: 'orders.psa.manual-checks',
                            label: 'messages.sitemap.orders.manual_checks',
                            identifier: orderDetailsBreadcrumbIdentifier
                        },
                        {
                            route: 'orders.psa.attachments',
                            label: 'messages.sitemap.orders.attachments',
                            identifier: orderDetailsBreadcrumbIdentifier
                        },
                        {
                            route: 'orders.psa.clarifications',
                            label: 'messages.sitemap.orders.clarifications',
                            identifier: orderDetailsBreadcrumbIdentifier
                        },
                        {
                            route: 'orders.psa.history',
                            label: 'messages.sitemap.orders.history',
                            identifier: orderDetailsBreadcrumbIdentifier
                        }
                    ]
                }
            ]
            : []
        ),
        ...($page.props.isOneWebshopSupported
            ? [
                {
                    route: 'orders.one_webshop.index',
                    label: 'messages.sitemap.orders.index_one_webshop',
                    showInSidebar: true,
                    id: 'one-webshop-orders-incoming',
                    children: []
                }
            ]
            : []
        ),
        ...($page.props.isWebglobeSupported
            ? [
                {
                    route: 'orders.webglobe.index',
                    label: 'messages.sitemap.orders.index_webglobe',
                    showInSidebar: true,
                    id: 'webglobe-orders-incoming',
                    children: []
                }
            ]
            : []
        ),
        ...($page.props.isWooCommerceSupported
            ? [
                {
                    route: 'orders.woocommerce.index',
                    label: 'messages.sitemap.orders.index_woo_commerce',
                    showInSidebar: true,
                    id: 'woocommerce-orders-incoming',
                    children: []
                }
            ]
            : []
        )
    ]
}
